module.exports = __webpack_public_path__ + "img/mariola-wentlandt@2x.134acd99.jpg";